export default __webpack_public_path__ + "static/media/carousel-4.d53cd45b.png";